// Literary Giants & Cultural Legends Data - Group Five (Final 6 Characters)

// Edgar Allan Poe's workout programs
const edgarAllanPoePrograms = [
    {
        id: 'gothic-darkness-conditioning',
        name: 'Gothic Darkness Conditioning',
        description: 'Haunting strength training that finds beauty in melancholy and power in darkness',
        pattern: '~w@d^_',
        reps: 18,
        sets: 3,
        focus: 'Gothic Beauty'
    },
    {
        id: 'raven-nevermore-workout',
        name: 'Raven Nevermore Workout',
        description: 'Mysterious conditioning that channels literary genius through brooding intensity',
        pattern: 'w_@d^~',
        reps: 84,
        sets: 1,
        focus: 'Brooding Genius'
    },
    {
        id: 'tell-tale-heart-training',
        name: 'Tell Tale Heart Training',
        description: 'Psychological thriller conditioning that builds strength through internal torment',
        pattern: '@^_~wd',
        reps: 14,
        sets: 10,
        focus: 'Psychological Power'
    },
    {
        id: 'masque-red-death-protocol',
        name: 'Masque Red Death Protocol',
        description: 'Macabre mastery training that confronts mortality while building eternal strength',
        pattern: 'd~w@_^',
        reps: 48,
        sets: 2,
        focus: 'Mortal Confrontation'
    },
    {
        id: 'baltimore-literary-training',
        name: 'Baltimore Literary Training',
        description: 'Southern gothic conditioning that transforms personal demons into artistic brilliance',
        pattern: '^@dw_~',
        reps: 40,
        sets: 2,
        focus: 'Artistic Transformation'
    },
    {
        id: 'master-of-mystery-mastery',
        name: 'Master of Mystery Mastery',
        description: 'The complete training system that created American Gothic literature through dark beauty',
        pattern: '~w@d^_!',
        reps: 40,
        sets: 2,
        focus: 'Dark Literary Mastery'
    }
];

// Oscar Wilde's workout programs
const oscarWildePrograms = [
    {
        id: 'aesthetic-philosophy-conditioning',
        name: 'Aesthetic Philosophy Conditioning',
        description: 'Art for art\'s sake training that builds beauty into every movement and gesture',
        pattern: 'lbsrco',
        reps: 15,
        sets: 6,
        focus: 'Aesthetic Beauty'
    },
    {
        id: 'wit-and-paradox-workout',
        name: 'Wit and Paradox Workout',
        description: 'Brilliant conversation conditioning that transforms clever wordplay into physical elegance',
        pattern: 'corsbl',
        reps: 31,
        sets: 3,
        focus: 'Clever Elegance'
    },
    {
        id: 'picture-dorian-gray-training',
        name: 'Picture Dorian Gray Training',
        description: 'Eternal youth conditioning that maintains perfect form while hiding internal corruption',
        pattern: 'sblcor',
        reps: 28,
        sets: 3,
        focus: 'Eternal Youth'
    },
    {
        id: 'society-scandal-protocol',
        name: 'Society Scandal Protocol',
        description: 'Victorian rebellion training that challenges social conventions through artistic courage',
        pattern: 'rocbls',
        reps: 89,
        sets: 1,
        focus: 'Social Rebellion'
    },
    {
        id: 'dandy-perfection-training',
        name: 'Dandy Perfection Training',
        description: 'Refined gentleman conditioning that makes every action a masterpiece of style',
        pattern: 'blsroc',
        reps: 46,
        sets: 2,
        focus: 'Stylish Perfection'
    },
    {
        id: 'irish-genius-mastery',
        name: 'Irish Genius Mastery',
        description: 'The complete training system that transformed wit into art and scandal into immortal beauty',
        pattern: 'lbsrco!',
        reps: 46,
        sets: 2,
        focus: 'Immortal Wit'
    }
];

// Wolfgang Amadeus Mozart's workout programs
const wolfgangAmadeusMozartPrograms = [
    {
        id: 'musical-prodigy-conditioning',
        name: 'Musical Prodigy Conditioning',
        description: 'Child genius training that transforms natural talent into superhuman musical ability',
        pattern: 'itkfam',
        reps: 5,
        sets: 27,
        focus: 'Prodigy Power'
    },
    {
        id: 'salzburg-court-workout',
        name: 'Salzburg Court Workout',
        description: 'Imperial court conditioning that performs divine music for emperors and kings',
        pattern: 'amfkit',
        reps: 62,
        sets: 2,
        focus: 'Imperial Performance'
    },
    {
        id: 'don-giovanni-training',
        name: 'Don Giovanni Training',
        description: 'Operatic mastery conditioning that creates dramatic music for legendary characters',
        pattern: 'kitmaf',
        reps: 178,
        sets: 1,
        focus: 'Operatic Drama'
    },
    {
        id: 'magic-flute-protocol',
        name: 'Magic Flute Protocol',
        description: 'Magical composition training that enchants audiences through supernatural musical beauty',
        pattern: 'fmakit',
        reps: 62,
        sets: 2,
        focus: 'Musical Magic'
    },
    {
        id: 'requiem-final-training',
        name: 'Requiem Final Training',
        description: 'Death-defying conditioning that composes immortal music while facing personal mortality',
        pattern: 'tiakfm',
        reps: 35,
        sets: 4,
        focus: 'Immortal Composition'
    },
    {
        id: 'divine-composer-mastery',
        name: 'Divine Composer Mastery',
        description: 'The complete training system that channeled heaven\'s music through human genius',
        pattern: 'itkfam!',
        reps: 35,
        sets: 4,
        focus: 'Divine Music'
    }
];

// Vincent van Gogh's workout programs
const vincentVanGoghPrograms = [
    {
        id: 'starry-night-conditioning',
        name: 'Starry Night Conditioning',
        description: 'Cosmic vision training that swirls universal energy into passionate artistic expression',
        pattern: 'cehkmv',
        reps: 37,
        sets: 4,
        focus: 'Cosmic Vision'
    },
    {
        id: 'sunflower-passion-workout',
        name: 'Sunflower Passion Workout',
        description: 'Brilliant yellow conditioning that channels solar energy into blazing artistic intensity',
        pattern: 'vkmedc',
        reps: 15,
        sets: 10,
        focus: 'Solar Passion'
    },
    {
        id: 'arles-yellow-house-training',
        name: 'Arles Yellow House Training',
        description: 'Southern French conditioning that finds artistic paradise in provincial simplicity',
        pattern: 'hmecvk',
        reps: 63,
        sets: 2,
        focus: 'Provincial Paradise'
    },
    {
        id: 'self-portrait-protocol',
        name: 'Self Portrait Protocol',
        description: 'Introspective training that builds strength through unflinching self-examination',
        pattern: 'ekvchm',
        reps: 37,
        sets: 4,
        focus: 'Self Examination'
    },
    {
        id: 'wheat-field-crows-training',
        name: 'Wheat Field Crows Training',
        description: 'Final masterpiece conditioning that transforms suffering into transcendent beauty',
        pattern: 'khmvec',
        reps: 70,
        sets: 2,
        focus: 'Transcendent Beauty'
    },
    {
        id: 'tortured-genius-mastery',
        name: 'Tortured Genius Mastery',
        description: 'The complete training system that turned personal anguish into immortal artistic vision',
        pattern: 'cehkmv!',
        reps: 37,
        sets: 4,
        focus: 'Anguished Vision'
    }
];

// Blackbeard's workout programs
const blackbeardPrograms = [
    {
        id: 'pirate-terror-conditioning',
        name: 'Pirate Terror Conditioning',
        description: 'Caribbean fear training that strikes terror into merchant vessels across the seven seas',
        pattern: '><$x&*',
        reps: 17,
        sets: 8,
        focus: 'Maritime Terror'
    },
    {
        id: 'queen-annes-revenge-workout',
        name: 'Queen Anne\'s Revenge Workout',
        description: 'Flagship command conditioning that leads the most feared pirate fleet in history',
        pattern: '*&x$><',
        reps: 40,
        sets: 3,
        focus: 'Fleet Command'
    },
    {
        id: 'burning-beard-training',
        name: 'Burning Beard Training',
        description: 'Psychological warfare conditioning that uses flaming hemp to create supernatural dread',
        pattern: 'x><*$&',
        reps: 17,
        sets: 8,
        focus: 'Supernatural Dread'
    },
    {
        id: 'ocracoke-island-protocol',
        name: 'Ocracoke Island Protocol',
        description: 'Coastal raiding training that dominates the American colonial shipping lanes',
        pattern: '$&*><x',
        reps: 171,
        sets: 1,
        focus: 'Coastal Domination'
    },
    {
        id: 'cutlass-pistol-training',
        name: 'Cutlass Pistol Training',
        description: 'Dual weapon conditioning that masters both blade and gun in close combat',
        pattern: '>&x*$<',
        reps: 14,
        sets: 9,
        focus: 'Dual Weapon Mastery'
    },
    {
        id: 'most-feared-pirate-mastery',
        name: 'Most Feared Pirate Mastery',
        description: 'The complete training system that made one name terrorize the entire Atlantic Ocean',
        pattern: '><$x&*!',
        reps: 34,
        sets: 4,
        focus: 'Atlantic Terror'
    }
];

// P.T. Barnum's workout programs
const ptBarnumPrograms = [
    {
        id: 'greatest-show-conditioning',
        name: 'Greatest Show Conditioning',
        description: 'Spectacular entertainment training that creates the most amazing show on earth',
        pattern: 'aqtfhy',
        reps: 25,
        sets: 4,
        focus: 'Spectacular Entertainment'
    },
    {
        id: 'humbug-showmanship-workout',
        name: 'Humbug Showmanship Workout',
        description: 'Master promotion conditioning that turns ordinary acts into extraordinary sensations',
        pattern: 'yhftqa',
        reps: 81,
        sets: 1,
        focus: 'Master Promotion'
    },
    {
        id: 'american-museum-training',
        name: 'American Museum Training',
        description: 'Curiosity collection conditioning that gathers the world\'s most amazing exhibits',
        pattern: 'tqayht',
        reps: 28,
        sets: 3,
        focus: 'Curiosity Collection'
    },
    {
        id: 'circus-ring-master-protocol',
        name: 'Circus Ring Master Protocol',
        description: 'Three-ring management training that orchestrates multiple spectacles simultaneously',
        pattern: 'fhytaq',
        reps: 3,
        sets: 28,
        focus: 'Multi-Ring Management'
    },
    {
        id: 'publicity-genius-training',
        name: 'Publicity Genius Training',
        description: 'Revolutionary marketing conditioning that creates public sensation through creative promotion',
        pattern: 'qtafhty',
        reps: 87,
        sets: 1,
        focus: 'Revolutionary Marketing'
    },
    {
        id: 'entertainment-emperor-mastery',
        name: 'Entertainment Emperor Mastery',
        description: 'The complete training system that invented modern entertainment and spectacular showmanship',
        pattern: 'aqtfhy!',
        reps: 29,
        sets: 4,
        focus: 'Entertainment Innovation'
    }
];

// Main Literary Giants & Cultural Legends trainers data object - Group Five
const historyFiveTrainersData = {
    'edgar-allan-poe': {
        id: 'edgar-allan-poe',
        name: 'Edgar Allan Poe',
        specialization: 'Gothic Literature & Dark Beauty Training',
        image: '/assets/images/edgar-allan-poe.jpg',
        experience: '40+ years',
        category: 'literary-cultural',
        color: '#191970',
        secondaryColor: '#000000',
        intro: `The master of American Gothic literature who found beauty in darkness and strength in melancholy. His training develops the psychological power to confront inner demons and transform personal torment into eternal artistic beauty. "All that we see or seem is but a dream within a dream."`,
        programs: edgarAllanPoePrograms
    },
    'oscar-wilde': {
        id: 'oscar-wilde',
        name: 'Oscar Wilde',
        specialization: 'Aesthetic Philosophy & Witty Elegance Training',
        image: '/assets/images/oscar-wilde.jpg',
        experience: '46+ years',
        category: 'literary-cultural',
        color: '#800080',
        secondaryColor: '#FFD700',
        intro: `The Irish genius who transformed wit into art and made scandal beautiful. His training develops aesthetic perfection and the courage to challenge society through artistic rebellion. Art for art's sake becomes strength for strength's sake.`,
        programs: oscarWildePrograms
    },
    'wolfgang-amadeus-mozart': {
        id: 'wolfgang-amadeus-mozart',
        name: 'Wolfgang Amadeus Mozart',
        specialization: 'Musical Prodigy & Divine Composition Training',
        image: '/assets/images/wolfgang-amadeus-mozart.jpg',
        experience: '35+ years',
        category: 'literary-cultural',
        color: '#DC143C',
        secondaryColor: '#FFFFFF',
        intro: `The child prodigy who channeled heaven's music through human genius. His training develops supernatural musical ability and the power to create beauty that transcends mortal limitations. Music is the universal language of the soul.`,
        programs: wolfgangAmadeusMozartPrograms
    },
    'vincent-van-gogh': {
        id: 'vincent-van-gogh',
        name: 'Vincent van Gogh',
        specialization: 'Cosmic Vision & Passionate Artistry Training',
        image: '/assets/images/vincent-van-gogh.jpg',
        experience: '37+ years',
        category: 'literary-cultural',
        color: '#FF8C00',
        secondaryColor: '#FFD700',
        intro: `The tortured genius who swirled cosmic energy into passionate artistic expression. His training transforms suffering into transcendent beauty and channels universal forces into personal vision. Through art, we touch the infinite.`,
        programs: vincentVanGoghPrograms
    },
    'blackbeard': {
        id: 'blackbeard',
        name: 'Blackbeard',
        specialization: 'Pirate Terror & Maritime Domination Training',
        image: '/assets/images/blackbeard.jpg',
        experience: '40+ years',
        category: 'literary-cultural',
        color: '#000000',
        secondaryColor: '#8B0000',
        intro: `The most feared pirate captain who terrorized the Atlantic with burning hemp in his beard. His training develops psychological warfare skills and the supernatural presence that makes enemies surrender before the battle begins.`,
        programs: blackbeardPrograms
    },
    'p-t-barnum': {
        id: 'p-t-barnum',
        name: 'P.T. Barnum',
        specialization: 'Spectacular Entertainment & Master Promotion Training',
        image: '/assets/images/p-t-barnum.jpg',
        experience: '81+ years',
        category: 'literary-cultural',
        color: '#FF0000',
        secondaryColor: '#FFD700',
        intro: `The showman who created the Greatest Show on Earth and invented modern entertainment. His training develops the promotional genius to turn ordinary acts into extraordinary sensations and the vision to give people dreams they never knew they wanted.`,
        programs: ptBarnumPrograms
    }
};

// Export the data
export default historyFiveTrainersData;